import { useTranslation } from '@packages/utils';
import useGetValidationData from 'components/Base/Form/validationRules';

const eventFamilyListKey = 'descriptions.admin-portal.family.event-family-list';

const useGetFormData = () => {
  const { t } = useTranslation({
    keyPrefix: eventFamilyListKey.concat('.actions.edit-family.modal.form'),
  });
  const { validationRules } = useGetValidationData();
  const editEventFamilyFormFields = {
    firstName: {
      name: 'firstName',
      label: t('first-name.LABEL', 'First Name'),
      placeholder: t('first-name.PLACEHOLDER', 'Enter first name'),
      rules: [validationRules.requiredField()],
    },
    lastName: {
      name: 'lastName',
      label: t('last-name.LABEL', 'Last Name'),
      placeholder: t('last-name.PLACEHOLDER', 'Enter last name'),
      rules: [validationRules.requiredField()],
    },
    email: {
      name: 'email',
      label: t('email.LABEL', 'Email'),
      placeholder: t('email.PLACEHOLDER', 'Enter email'),
      rules: [validationRules.requiredField(), validationRules.email()],
    },
    phone: {
      name: 'phone',
      label: t('mobile.LABEL', 'Mobile'),
      placeholder: t('mobile.PLACEHOLDER', 'Enter phone number'),
      rules: [validationRules.requiredField(), validationRules.phoneNumber()],
    },
  };

  return { editEventFamilyFormFields };
};

export default useGetFormData;
